import {
    createQuery,
    updateOneFieldQuery,
    updatePagePicture,
    updatePageCoverPictures,
    updatePageAttachments,
    getPageAttachments,
    destroyPageAttachment,
    updatePageAttachment,
    fetchLinesheets,
    // fetchLinesheet,
    updatePageTags,
    getPageEvents,
    updatePageEvents,
    destroyPageEvent,
    linkInstagramAccount,
    unlinkInstagramAccount,
    getInstagramMedia,
} from "queries/brand-profile";
import { mutateAsync, requestAsync } from "lib/api";

import {
    BRAND_PROFILE_REQUEST,
    BRAND_PROFILE_FAILURE,
    BRAND_PROFILE_SUCCESS,
    BRAND_PROFILE_CHANGE,
    BRAND_PROFILE_RESET,
    ATTACHMENT_FETCH_SUCCESS,
    ATTACHMENT_ADD,
    ATTACHMENT_REMOVE,
    ATTACHMENT_SUCCESS,
    BRAND_PROFILE_PICTURES_CHANGE,
    BRAND_PROFILE_PICTURE_CHANGE,
    BRAND_PROFILE_PICTURE_CHANGE_COMPLETE,
    CATALOGS_REQUEST,
    BRAND_PROFILE_CATALOGS_SUCCESS,
    BRAND_PROFILE_EVENTS_SUCCESS,
    BRAND_PROFILE_EVENTS_DELETE_SUCCESS,
    CATALOG_ENTRIES_RESET,
    // CATALOG_ENTRIES_REQUEST,
    // CATALOG_ENTRIES_RESULT,
    INSTAGRAM_FEED_SUCCESS,
    INSTAGRAM_LINK_FAILURE,
    INSTAGRAM_LINK_SUCCESS,
    INSTAGRAM_UNLINK_FAILURE,
    INSTAGRAM_UNLINK_SUCCESS,
    ANALYTICS_TRACK,
    CATALOG,
} from "constants/action-types";

import { OTS_CLICKED_GUEST_VIEW } from "constants/analytics";

import { EventTypes } from "redux-segment";

import { add as snackbarAdd } from "actions/snackbars";

import Globalize from "globalize";

export const handleSuccessfulFetch = (data) => {
    return {
        type: BRAND_PROFILE_SUCCESS,
        payload: data,
    };
};

export const onFetchStart = () => {
    return {
        type: BRAND_PROFILE_REQUEST,
    };
};

export const onFetchFailure = () => {
    return {
        type: BRAND_PROFILE_FAILURE,
        error: "General Error",
    };
};

export const brandProfileUpdate = (data) => {
    return {
        type: BRAND_PROFILE_CHANGE,
        payload: [data.body.data[0].id],
    };
};

export const attachmentFetchSuccess = (data) => {
    return {
        type: ATTACHMENT_FETCH_SUCCESS,
        payload: data,
    };
};

export const resetBrandProfile = () => {
    return {
        type: BRAND_PROFILE_RESET,
    };
};

export const createBasicProfile = (data) => {
    return (dispatch) => {
        dispatch(mutateAsync(createQuery(data))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch({
                    type: BRAND_PROFILE_SUCCESS,
                    payload: data.transformed._result,
                    meta: {
                        analytics: {
                            eventType: EventTypes.track,
                            eventPayload: {
                                event: "Online Trade Show Profile Created",
                            },
                        },
                    },
                });
            } else if (status === 409) {
                //for some reason it already exists but we missed it of fetch, just reload
                window.location.reload(true);
            } else if (status === 403) {
                //user does not have permission to create but somehow got the creation prompt
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage(
                            "You do not have permission to create a profile page for this brand",
                        ),
                    }),
                );
            } else {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const updateProfilePage = (pageId, fieldName, value) => {
    return (dispatch) => {
        dispatch(mutateAsync(updateOneFieldQuery(pageId, fieldName, value))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                if (fieldName === "social_links") {
                    dispatch(
                        snackbarAdd({
                            message: Globalize.formatMessage("Brand profile updated"),
                        }),
                    );
                }

                if (fieldName === "legacy_linesheet_id" && !value) {
                    dispatch({ type: CATALOG_ENTRIES_RESET });
                }

                dispatch(brandProfileUpdate(data));
            } else if (status === 409) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("You do not have permission to modify this page"),
                    }),
                );
            } else {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const updateProfilePicture = (pageId, pageMediaId) => {
    return (dispatch) => {
        dispatch({
            type: BRAND_PROFILE_PICTURE_CHANGE,
        });
        dispatch(mutateAsync(updatePagePicture(pageId, pageMediaId))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch(brandProfileUpdate(data));
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Brand profile updated"),
                    }),
                );
                dispatch({
                    type: BRAND_PROFILE_PICTURE_CHANGE_COMPLETE,
                });
            } else if (status >= 400 && status < 500) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("You do not have permission to modify this page"),
                    }),
                );
                dispatch({
                    type: BRAND_PROFILE_PICTURE_CHANGE_COMPLETE,
                });
            } else {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
                dispatch({
                    type: BRAND_PROFILE_PICTURE_CHANGE_COMPLETE,
                });
            }
        });
    };
};

export const updateProfileCoverPictures = (pageId, pageMediaIds) => {
    return (dispatch) => {
        dispatch({
            type: BRAND_PROFILE_PICTURES_CHANGE,
        });
        dispatch(mutateAsync(updatePageCoverPictures(pageId, pageMediaIds))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch(brandProfileUpdate(data));
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Brand profile updated"),
                    }),
                );
            } else if (status >= 400 && status < 500) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Brand profile cannot have more than 5 cover pictures"),
                    }),
                );
            } else {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const updateProfileAttachments = (pageId, uploadId) => {
    return (dispatch) => {
        dispatch({
            type: ATTACHMENT_ADD,
        });
        dispatch(mutateAsync(updatePageAttachments(pageId, uploadId))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch({
                    type: ATTACHMENT_SUCCESS,
                    payload: data.transformed._result,
                });
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("File added"),
                    }),
                );
            } else {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const getAttachments = (pageId) => {
    return (dispatch) => {
        dispatch(requestAsync(getPageAttachments(pageId))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch(attachmentFetchSuccess(data.transformed._result));
                //do nothing if a 404?
            } else if (status >= 500) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const destroyAttachment = (pageId, pageAttachmentId) => {
    return (dispatch) => {
        dispatch(mutateAsync(destroyPageAttachment(pageId, pageAttachmentId))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch({
                    type: ATTACHMENT_REMOVE,
                    payload: pageAttachmentId,
                });
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("File removed"),
                    }),
                );
            } else if (status === 404) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("This profile page no longer exists"),
                    }),
                );
            } else if (status === 403 || status === 401) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("You do not have permission to edit this file"),
                    }),
                );
            } else {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const updateAttachmentName = (pageId, pageAttachmentId, value) => {
    return (dispatch) => {
        dispatch(mutateAsync(updatePageAttachment(pageId, pageAttachmentId, value))).then((data) => {
            const { status } = data;
            if (status >= 400 && status < 500) {
                snackbarAdd({
                    message: Globalize.formatMessage("You do not have permission to edit this page"),
                });
            } else if (status >= 500) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const getLinesheets = (brandId) => {
    return (dispatch) => {
        dispatch({
            type: CATALOGS_REQUEST,
        });
        dispatch(requestAsync(fetchLinesheets(brandId))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch({
                    type: BRAND_PROFILE_CATALOGS_SUCCESS,
                    payload: data.transformed,
                });
            } else {
                dispatch({
                    type: BRAND_PROFILE_CATALOGS_SUCCESS,
                });
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const getLinesheet = (brandId, catalogId) => {
    return {
        payload: {
            id: catalogId,
            filters: {
                __meta: true,
                __guest: true,
                __fields: "__all",
                __limit: 15,
                __populate: ["__item", "__variant"],
                __type: "item",
                __archived: false,
                __view_disabled: false,
            },
        },
        meta: {
            key: `${catalogId}:ots`,
            cacheKey: `${catalogId}:ots`,
        },
        type: CATALOG.ENTRIES.FETCH.START,
    };
    // return (dispatch, getState) => {
    //     if (catalogId) {
    //         dispatch({ type: CATALOG_ENTRIES_RESET });
    //         dispatch({
    //             type: CATALOG_ENTRIES_REQUEST,
    //             payload: { reset: true },
    //         });
    //         dispatch(requestAsync(fetchLinesheet(brandId, catalogId))).then(data => {
    //             const { status } = data;
    //             if (status >= 200 & status < 300) {
    //                 return dispatch({
    //                     type: CATALOG_ENTRIES_RESULT,
    //                     payload: data.transformed._result,
    //                     meta: { replace: true },
    //                 });
    //             }
    //             if (status >= 500) {
    //                 dispatch(
    //                     snackbarAdd({
    //                         message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
    //                     }),
    //                 );
    //             }
    //             return dispatch({
    //                 type: CATALOG_ENTRIES_RESULT,
    //                 payload: new Error(status),
    //                 error: true,
    //             });
    //         });
    //     }
    // };
};

export const updatePageCategories = (pageId, brandCategories) => {
    return (dispatch) => {
        dispatch(mutateAsync(updatePageTags(pageId, brandCategories))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch(brandProfileUpdate(data));
            } else if (status === 401) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("You do not have permission to edit this page"),
                    }),
                );
            } else {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const getEventsForPage = (pageId) => {
    return (dispatch) => {
        dispatch(requestAsync(getPageEvents(pageId))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch({
                    type: BRAND_PROFILE_EVENTS_SUCCESS,
                    payload: data.transformed._result.length ? data : [],
                });
            } else if (status >= 500) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const modifyPageEvents = (pageId, eventId) => {
    return (dispatch) => {
        dispatch(mutateAsync(updatePageEvents(pageId, eventId))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch({
                    type: BRAND_PROFILE_EVENTS_SUCCESS,
                    payload: data,
                });
            } else if (status === 401) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("You do not have permission to edit this page"),
                    }),
                );
            } else {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

export const deletePageEvent = (pageId, eventId) => {
    return (dispatch) => {
        dispatch(mutateAsync(destroyPageEvent(pageId, eventId))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                dispatch({
                    type: BRAND_PROFILE_EVENTS_DELETE_SUCCESS,
                    payload: eventId,
                });
            } else if (status === 401) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("You do not have permission to edit this page"),
                    }),
                );
            } else if (status >= 500) {
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    }),
                );
            }
        });
    };
};

// TODO
export const unlinkInstagramFromBrandProfile = (pageId) => {
    return (dispatch) => {
        return dispatch(mutateAsync(unlinkInstagramAccount(pageId))).then((res) => {
            const { body, status } = res;

            if (status >= 200 && status < 300) {
                return dispatch({ type: INSTAGRAM_UNLINK_SUCCESS });
            } else {
                return dispatch({
                    type: INSTAGRAM_UNLINK_FAILURE,
                    payload: body.error,
                    error: true,
                });
            }
        });
    };
};

export const linkInstagramToBrandProfile = (pageId, authId) => {
    return (dispatch) => {
        return dispatch(mutateAsync(linkInstagramAccount(pageId, authId))).then((res) => {
            const { body, status } = res;

            if (status >= 200 && status < 300) {
                return dispatch({ type: INSTAGRAM_LINK_SUCCESS });
            } else {
                return dispatch({
                    type: INSTAGRAM_LINK_FAILURE,
                    payload: body.error,
                    error: true,
                });
            }
        });
    };
};

export const getInstagramMediaForBrandProfile = (pageId) => {
    return (dispatch) => {
        return dispatch(requestAsync(getInstagramMedia(pageId))).then((res) => {
            const { status, transformed } = res;

            if (status >= 200 && status < 300) {
                return dispatch({
                    type: INSTAGRAM_FEED_SUCCESS,
                    payload: transformed._result,
                });
            } else {
                return dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Unable to retrieve Instagram feed."),
                    }),
                );
            }
        });
    };
};

export const trackShopBrandClick = (brandId) => {
    return (dispatch) => {
        dispatch({
            meta: {
                analytics: {
                    eventPayload: {
                        options: {
                            groupId: brandId,
                        },
                        properties: {
                            brand: brandId,
                        },
                        event: OTS_CLICKED_GUEST_VIEW,
                    },
                    eventType: EventTypes.track,
                },
            },
            type: ANALYTICS_TRACK,
        });
    };
};
